import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { themr } from 'react-css-themr';
import { provideHooks } from 'redial';

import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import { fetchLatestArticlesAction } from '../../redux/actions/latest-articles';

@provideHooks({
    fetch: ({ dispatch, force }) => {
        const { iris: { host }, sections = {} } = config;

        const endpoint =
            host + config.iris['section-latest'].replace('{{ID}}', sections['nyheter/meninger']);

        const fetchLatestArticles = fetchLatestArticlesAction({
            endpoint,
            force,
        });

        return Promise.all([dispatch(fetchLatestArticles)]);
    },
})
@connect((state) => ({
    latest: state.latestArticles.latest,
}))
@themr('ReferenceFront')
export default class ReferenceFront extends Component {
    /* eslint-disable react/forbid-prop-types */
    static propTypes = {
        theme: PropTypes.object,
        latest: PropTypes.array,
    };
    /* eslint-enable react/forbid-prop-types */

    static defaultProps = {
        theme: {},
        latest: [],
    };

    render() {
        const { theme: { front }, latest } = this.props;

        // Disabling the index as key since it does not matter at all for this list.
        // Will never end up in production.
        /* eslint-disable react/no-array-index-key  */
        const latestArticles = latest.map(({ id, promotionContent: { title } }, index) => (
            <li key={index}>
                <Link to={`/i/${id}/`}>{title.value}</Link>
            </li>
        ));
        /* eslint-enable react/forbid-prop-types */

        return (
            <article>
                <section className={front}>
                    <h2>(Old) Staging/development</h2>
                    <ul>
                        <li>
                            <Link to="/i/rLodl/">
                                Article example 2: Jensen-varsel (plain article, long)
                            </Link>
                        </li>
                        <li>
                            <Link to="/i/g7rvk/">
                                Article example 3: Lorem Ipsum (many components)
                            </Link>
                        </li>
                    </ul>

                    <h2>In production (beta.vg.no)</h2>
                    <ul>
                        <li>
                            <Link to="/i/55qw1/">Nå skal vi skilles, Johanne</Link>
                        </li>
                        <li>
                            <Link to="/i/55qw1/?layout=promo">
                                Nå skal vi skilles, Johanne (promo version)
                            </Link>
                        </li>
                        <li>
                            <Link to="/i/WV3x2">Prest avsatt (plain news)</Link>
                        </li>
                        <li>
                            <Link to="/i/01X4J">Sør-Sudan i krise (feature)</Link>
                        </li>
                    </ul>

                    <h2>Hildes testfiles:</h2>
                    <ul>
                        <li>
                            <Link to="/i/wPqQn/">Hildes testfiles: Plain article</Link>
                        </li>
                        <li>
                            <Link to="/i/awAEO/">Hildes testfiles: Meninger article</Link>
                        </li>
                        <li>
                            <Link to="/i/4qPeV/">Hildes testfiles: Sports article</Link>
                        </li>
                        <li>
                            <Link to="/i/kJ5rX/">Hildes testfiles: Plain feature article</Link>
                        </li>
                        <li>
                            <Link to="/i/Joa5X/">Hildes testfiles: Sports feature article</Link>
                        </li>
                    </ul>

                    <h2>Recent meninger articles</h2>
                    <ul>{latestArticles}</ul>
                </section>
            </article>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/screens/front/index.js
 **/